<div class="card p-l-10 mb-2" *ngIf="links.length != 0">
  <div class="card-body p-0">
      <div class="row links-panel" *ngFor="let link of links">
          <div class="col-12">
              <a href="{{link.href}}" target="_blank">{{link.title}}</a>
          </div>
      </div>
  </div>
</div>